import api from "../api";
import to from "await-to-js";
import { listAll, l_listAll } from "../queryGenerator";

const aboutRequests = {
  getAboutHks: async (queryData) => {
    // console.log(queryData);
    let resourceString = await l_listAll(
      queryData.resource,
      queryData.language
    );
    // console.log(resourceString);

    let [error, response] = await to(api.GETPUBLIC_QUERY(resourceString));
    // console.log(error, response);

    if (response.status === "fail") {
      throw { ...response };
    } else {
      return response;
    }
  },
};

export default aboutRequests;
